type State = {
  attestation_modal: {
    open: boolean;
  };
  confirmation_modal: {
    open: boolean;
  };
  decline_attestation_modal: {
    open: boolean;
  };
  error_modal: {
    open: boolean;
  };
  in_progress: boolean;
  success_modal: {
    open: boolean;
    numbers: string[];
  };
};

type Action =
  | {
      type: "ATTESTATION_MODAL:OPEN";
    }
  | {
      type: "ATTESTATION_MODAL:CLOSE";
    }
  | {
      type: "CONFIRMATION_MODAL:OPEN";
    }
  | {
      type: "CONFIRMATION_MODAL:CLOSE";
    }
  | {
      type: "IN_PROGRESS:TOGGLE";
      value?: boolean;
    }
  | {
      type: "SUCCESS_MODAL:OPEN";
      numbers: string[];
    }
  | {
      type: "SUCCESS_MODAL:CLOSE";
    }
  | {
      type: "DECLINE_ATTESTATION_MODAL:OPEN";
    }
  | {
      type: "DECLINE_ATTESTATION_MODAL:CLOSE";
    }
  | {
      type: "ERROR_MODAL:OPEN";
    }
  | {
      type: "ERROR_MODAL:CLOSE";
    }
  | {
      type: "RESET";
    };

export function init(state: Partial<State>): State {
  return {
    attestation_modal: {
      open: false,
    },
    confirmation_modal: {
      open: false,
    },
    decline_attestation_modal: {
      open: false,
    },
    in_progress: false,
    success_modal: {
      open: false,
      numbers: [],
    },
    error_modal: {
      open: false,
    },
  };
}

export function reducer(state: State, action: Action): State {
  switch (action.type) {
    case "ATTESTATION_MODAL:OPEN":
      return {
        ...state,
        attestation_modal: {
          open: true,
        },
      };
    case "ATTESTATION_MODAL:CLOSE":
      return {
        ...state,
        attestation_modal: {
          open: false,
        },
      };
    case "CONFIRMATION_MODAL:OPEN":
      return {
        ...state,
        confirmation_modal: {
          open: true,
        },
      };
    case "CONFIRMATION_MODAL:CLOSE":
      return {
        ...state,
        confirmation_modal: {
          open: false,
        },
      };
    case "IN_PROGRESS:TOGGLE":
      return {
        ...state,
        in_progress:
          action.value !== undefined ? action.value : !state.in_progress,
      };
    case "SUCCESS_MODAL:OPEN":
      return {
        ...state,
        success_modal: {
          open: true,
          numbers: action.numbers,
        },
      };
    case "SUCCESS_MODAL:CLOSE":
      return {
        ...state,
        success_modal: {
          open: false,
          numbers: [],
        },
      };
    case "DECLINE_ATTESTATION_MODAL:OPEN":
      return {
        ...state,
        decline_attestation_modal: {
          open: true,
        },
      };
    case "DECLINE_ATTESTATION_MODAL:CLOSE":
      return {
        ...state,
        decline_attestation_modal: {
          open: false,
        },
      };
    case "ERROR_MODAL:OPEN":
      return {
        ...state,
        error_modal: {
          open: true,
        },
      };
    case "ERROR_MODAL:CLOSE":
      return {
        ...state,
        error_modal: {
          open: false,
        },
      };
    case "RESET":
      return init({});
    default:
      return state;
  }
}
